"use client";

import { getLabel, SORT } from "@/constants/sort.constant";
import useUrlParams from "@/hooks/url";
import { CategoryType } from "@/types/category.type";
import { Tab, Tabs } from "@mui/material";
import { SyntheticEvent } from "react";

export default function Sort({ category }: { category: CategoryType }) {
  const { updateURLParams, searchParams } = useUrlParams();
  const sort = searchParams.get("sort") || SORT.NEWEST;
  const handleChange = (_: SyntheticEvent<Element, Event>, value: string) => {
    updateURLParams({ sort: value });
  };

  return (
    <div className="border-b border-zinc-200 px-0 md:px-4 pt-4">
      <div className="text-lg font-semibold md:px-0 px-4">{category.title}</div>
      <div className="flex items-center gap-x-6">
        <div className="font-semibold md:block hidden">Sort By</div>
        <Tabs
          value={sort}
          onChange={handleChange}
          variant="scrollable"
          allowScrollButtonsMobile
        >
          {Object.values(SORT).map((value, index) => (
            <Tab key={index} label={getLabel(value)} value={value} />
          ))}
        </Tabs>
      </div>
    </div>
  );
}
